/**
 * Testcase component is responsible for rendering a table that displays the details
 * of test cases for a student's programming submission. It shows the input, output,
 * expected output, pass/fail status, and marks for each test case. Additionally,
 * it allows downloading the test case details and viewing error messages in a modal.

 * The component iterates over the testResults array and renders each test case's details
 * in a table row. If a test case has a runtime error , a clickable link
 * is provided to open a modal showing the detailed error messages. Additionally, there 
 * are icons to indicate pass/fail status and a button to download the test case details.
 */

// import React from "react";
// import Table from "react-bootstrap/Table";
// import { GoThumbsdown, GoThumbsup } from "react-icons/go";
// import { useState } from "react";

import log from "loglevel";
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { IoMdDownload } from "react-icons/io";
import * as constants from "Constants";
import Modal from "react-bootstrap/Modal";
import "Screens1/Student/Course/Content/Programming/ComponentsNew/Testcase/TestCase.css"

const mappedIcon = { 'false':'❌' || 'failed','true':'✅' || 'passed'}

function Testcase(props) {
  //state for showing pop upp screen for errors with the execution
  log.log("this are props", props)
  const [showPopup, setShowPopUP] = React.useState(0);
  const rowHasError = (row) =>
    Boolean(row.error_messages || row.compiler_errors || row.return_code || row.verdict);
  const hasError = props.testResults?.some(rowHasError) || false;
  log.log("props.testresults", props.testResults);
  return (
    <>
    <TableContainer component={Paper} sx={{ backgroundColor: 'white' }}>
      <Table
        sx={{
          minWidth: 650,
          backgroundColor: 'white',
          '& .MuiTableCell-root': {
            backgroundColor: 'white',
          },
          '& .MuiTableHead-root .MuiTableCell-root': {
            fontWeight: 'bold',
          },
        }}
        size="small"
        aria-label="a dense table"
      >
        <TableHead>
          <TableRow>
            <TableCell align="center">ID</TableCell>
            <TableCell align="center">Input</TableCell>
            <TableCell align="center">Actual Output</TableCell>
            <TableCell align="center">Expected Output</TableCell>
            <TableCell align="center">Marks</TableCell>
            <TableCell align="center">Status</TableCell>
            {hasError && 
              <TableCell align="center">Error</TableCell>
            }
            <TableCell align="center">Download</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.testResults.map((row,i) => (
            <TableRow
              key={row.id}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
                backgroundColor: 'white',
              }}
            >
              <TableCell component="th" scope="row" align="center">
                {i+1 || ' '}
              </TableCell>

              <TableCell 
                align="left"
              >
                <div className='m-2'>
                  <code className='code'>
                    {row.testcase_input || ' '}
                  </code>
                </div>
              </TableCell>

              <TableCell 
                align="left"
              >
                <div className='m-2'>
                  <code className='code'>
                    {row.student_output ||
                      (rowHasError(row)
                        ? `No output — ${row.verdict || 'Runtime Error'}`
                        : 'nothing to display')}
                  </code>
                </div>
              </TableCell>

              <TableCell 
                align="left"
              >
                <div className='m-2'>
                  <code className='code'>
                    {row.testcase_output || ' '}
                  </code>
                </div>
              </TableCell>

              <TableCell align="center">
                {row.marks_obtained || '0'}
              </TableCell>

              <TableCell align="center">{mappedIcon[row.passed] || ' '}</TableCell>
              {hasError && 
              <TableCell align="center">
                <OverlayTrigger overlay={<Tooltip>Click to Expand</Tooltip>}>
                  <a
                    variant="outline-secondary"
                    onClick={() => setShowPopUP(i + 1)}
                    style={{
                      color: "red",
                    }}
                  >
                    {rowHasError(row) ? (
                      <u>{row.verdict || 'Runtime Error'}</u>
                    ) : null}
                  </a>
                </OverlayTrigger>
              </TableCell>

              } 
              <TableCell align="center">
                <OverlayTrigger
                  overlay={<Tooltip>Download Testcase{i + 1}</Tooltip>}
                >
                  <a
                    onClick={() =>
                      props.testcasesExportHandler(
                        constants.base_url +
                          "/evalpro/testcase/export_archive/" +
                          row.id,
                        "testcase" + row.id
                      )
                    }
                    style={{cursor:"pointer"}}
                  >
                    {" "}
                    <IoMdDownload size="20" />
                  </a>
                </OverlayTrigger>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <Modal
    show={showPopup ? true : false}
    dialogClassName="modal-90w"
    onHide={() => setShowPopUP(0)}
    size="xl"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    >
      <Modal.Header closeButton>Error Messages</Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12 col1">
            <textarea
              className="textarea1"
              value={props.testResults[showPopup - 1]?.error_messages}
              style={{
                color: "red",
                backgroundColor: "black",
                width: "100%",
                height: "200px",
              }}
              disabled
            ></textarea>
          </div>
        </div>
      </Modal.Body>
    </Modal>

    </>
  );
}

export default Testcase;
